import * as api from '../linksApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { IEntityWithMessages } from '../../../services/HttpService';
import {
  ILink,
  linkActionCreators,
  LinkActionKeys,
  UpdateLink
  } from '..';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* updateLinkSaga(action: UpdateLink) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IEntityWithMessages<ILink> = yield call(api.updateLink, action.payload.link);

  if (response.value) {
    yield put(linkActionCreators.setLinks([response.value]));
  }

  yield processMessages(response);

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateLink() {
  yield takeEvery(LinkActionKeys.UPDATE_LINK, updateLinkSaga);
}
